import ReactDOM from 'react-dom/client';
import React from 'react';
import { ToastContainer } from 'react-toastify';
import { TenantContext } from '../../../context/tenant-context';
import 'react-toastify/dist/ReactToastify.css';
import { v2Component } from '../../../index';
import { ProductImages } from './product-images';

export function initProductImages() {
  document.getElementsByName('product-images').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const { tenant, contextPath, productId, ...props } = Object.assign({}, element.dataset) as any;
      root.render(
        v2Component(
          <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
            <ToastContainer />
            <ProductImages productId={productId} {...props} />
          </TenantContext.Provider>,
        ),
      );

      const event = new CustomEvent('change');
      element.dispatchEvent(event);
    }
  });
}
